<div class="wrapper">
@for (item of fields(); track item) {
  <div class="item">
    <div class="item__name">{{item.name}}</div>
    <div class="item__value">{{item.value}}</div>
  </div>
}
</div>
